import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';


@Injectable({
  providedIn: 'root'
})
export class MetaService {

    constructor(private metaService: Meta) { }
    update(data) {
      if (data && data.keywords) {
        this.metaService.updateTag({
          name: 'keywords',
          content: data.keywords
        })
      } else {
        this.metaService.removeTag("name='keywords'");
      }

      if (data && data.description) {
        this.metaService.updateTag({
          name: 'description',
          content: data.description
        })
      } else {
        this.metaService.removeTag("name='description'");
      }

      if (data && data.classification) {
        this.metaService.updateTag({
          name: 'classification',
          content: data.classification
        })
      } else {
        this.metaService.removeTag("name='classification'");
      }

      if (data && data.category) {
        this.metaService.updateTag({
          name: 'category',
          content: data.category
        })
      } else {
        this.metaService.removeTag("name='category'");
      }
    } 
}
